import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Client } from './client';

export class Site extends BaseClass implements BaseRepository {
  name: string;
  client: Client;
  otherSite: boolean;
  documentUrl: string;

  constructor()
  constructor(
    name: string, client: Client, otherSite: boolean, documentUrl?: string)
  constructor(
    name?: string, client?: Client, otherSite?: boolean, documentUrl?: string) {
    super();

    this.name = this.trim(name);
    this.client = client || null;
    this.otherSite = otherSite;
    this.documentUrl = documentUrl;
  }

  static fromObject(object: Site): Site {
    return Object.assign(new Site(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
